var map = {
	"./completelist/GameSetup": [
		247,
		380,
		247
	],
	"./flappy/GameSetup": [
		9634,
		86,
		532,
		787,
		634
	],
	"./minigolf/GameSetup": [
		9351,
		86,
		732
	],
	"./quizrush/GameSetup": [
		1559,
		380,
		559
	],
	"./runner/GameSetup": [
		9696,
		86,
		532,
		787,
		696
	],
	"./sidescroller/GameSetup": [
		9441,
		86,
		532,
		787,
		441
	],
	"./snake/GameSetup": [
		1499,
		86,
		532,
		880
	],
	"./stacker/GameSetup": [
		8201,
		201
	],
	"./verticalclimber/GameSetup": [
		687,
		532,
		787,
		687
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1428;
module.exports = webpackAsyncContext;